/**
 * Returns a new list where the item at the given index has the changes merged
 * in. Every other item keeps its identity, and the source list is untouched —
 * use this instead of assigning into a list that lives in state.
 */
export const replaceAtIndex = <T>(
  items: Array<T>,
  index: number,
  changes: Partial<T>
): Array<T> =>
  items.map((item, itemIndex) =>
    itemIndex === index ? { ...item, ...changes } : item
  );
